var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-carousel'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client container"},[_c('div',{staticClass:"row"})])
}]

export { render, staticRenderFns }